import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {},
  paragraph: {
    padding: theme.spacing(2, 0),
    textAlign: 'left',
    color: theme.palette.black.main,
  },
  textField: {
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      fontWeight: 600,
    },
    '& .MuiGrid-item': {
      height: '100px',
    },
    marginTop: theme.spacing(-3),
  },
}))
